import { globalAxios } from "../index";
export default {
  namespaced: true,
  state: {
    orderList: [],
    orderDetail: {
      order_id: null,
      order_code: "",
      order_type: 1,
      order_customer_full_name: "",
      order_status: null,
      order_rider_full_name: null,
      order_store: [
        {
          store_id: null,
          store_name: "",
          store_order_status: 1,
          store_order_send_data: 0,
          store_order_time_end: null,
          store_image_check_point: null,
          store_note: null,
        },
      ],
      order_discount_code: null,
      order_net_price: null,
      order_payment_type: 1,
      order_is_paymented: 1,
      order_time_start: "",
      order_time_end: null,
      order_discount: null,
      order_update_at: null,
      order_check_product: [
        {
          order_detail_store_name: "",
          order_detail_product: "",
          order_detail_product_image: "",
          order_detail_product_seller_price: null,
          order_detail_amount: null,
          order_detail_check_order: 0,
        },
      ],
    },
  },
  mutations: {
    resetOrderDetail(state) {
      state.orderDetail = {
        order_id: null,
        order_code: "",
        order_type: 1,
        order_customer_full_name: "",
        order_status: null,
        order_update_at: null,
        order_rider_full_name: null,
        order_store: [
          {
            store_id: null,
            store_name: "",
            store_order_status: 1,
            store_order_send_data: 0,
            store_order_time_end: null,
            store_image_check_point: null,
            store_note: null,
          },
        ],
        order_discount_code: null,
        order_net_price: null,
        order_payment_type: 1,
        order_is_paymented: 1,
        order_time_start: "",
        order_time_end: null,
        order_discount: null,
        order_check_product: [
          {
            order_detail_store_name: "",
            order_detail_product: "",
            order_detail_product_image: "",
            order_detail_product_seller_price: null,
            order_detail_amount: null,
            order_detail_check_order: 0,
          },
        ],
        order_add_on: { order_add_on_list: [] },
      };
    },
    setOrderDetail(state, data) {
      state.orderDetail = data;
    },
    fetchDataOrder(state, data) {
      state.orderList = data;
    },
    approveOrder(state, data) {
      let index = state.orderList.findIndex(
        (val) => val.order_id == data.order_id
      );
      Object.assign(state.orderList[index], data);
    },
    cancelOrder(state, order_id) {
      let index = state.orderList.findIndex((val) => val.order_id == order_id);
      let order = { order_status: 7 };
      Object.assign(state.orderList[index], order);
      // state.orderList.splice(index, 1);
    },
  },
  actions: {
    playAudioOrder({ state }) {
      // window.postMessage("pause", "*");
      // Print.postMessage("pause");
      // if (state.orderList.some(val => val.order_status == 1 &&
      //   new Date(val.order_time_start).getTime().toLocaleString() <=
      //   new Date().getTime().toLocaleString())) {
      // window.postMessage("play", "*");
      //   Print.postMessage("play");
      // }
    },
    rejectOrder({ commit, rootState }, { order_id, form }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      form.store_id = +rootState.Auth.refeshStoreID;
      return globalAxios
        .put(
          rootState.baseAPIURL + "restaurant/cancelOrderById/" + order_id,
          form,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("cancelOrder", order_id);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    completeOrder({ commit, rootState }, order_id) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .put(
          rootState.baseAPIURL +
            "restaurant/approveOrder/" +
            order_id +
            "/actionId/4",
          null,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("approveOrder", res.data.data);
            return res.data;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    approveOrder({ commit, rootState }, payload) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .put(
          rootState.baseAPIURL +
            "restaurant/approveOrder/" +
            payload.orderId +
            "/actionId/3",
          { order_minute: payload.orderMinute },
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          console.log(res);
          if (res.data.msg == true) {
            commit("approveOrder", res.data.data);
            return res.data;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    sendToReadOrder({ commit, rootState }, order_id) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .post(
          rootState.baseAPIURL + "restaurant/readOrder/" + order_id,
          { store_id: rootState.Auth.refeshStoreID },
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
    fetchDataOrder({ commit, rootState }) {
      const axiosConfig = {
        headers: {
          Authorization: rootState.Auth.accToken,
        },
      };
      return globalAxios
        .get(
          rootState.baseAPIURL +
            "restaurant/allOrderByStoreId/" +
            rootState.Auth.refeshStoreID,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("fetchDataOrder", res.data.data);
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => false);
    },
  },
  getters: {},
};
